import "animate.css";
import { Button, Container } from "gf-ui";
import React from "react";
import { useNavigate } from 'react-router-dom';
import { TIPOLOGIE } from ".";
import { CreditsColon } from "./coloneRetto";
import HeaderColon from "./coloneRetto/components/HeaderColon";
import { CreditsSenologia } from "./senologia";
import HeaderSenologia from "./senologia/components/HeaderSenologia";
import { FaArrowLeft } from 'react-icons/fa'
import Footer from "../components/Footer";
import HeaderTicketPsStranieri from "./ticketPsStranieri/components/HeaderTicketPsStranieri";
import CreditsTicketPsStranieri from "./ticketPsStranieri/CreditsTicketPsStranieri";


const Credits = ({ tipologia, backlink }) => {

  const navigate = useNavigate()
  
  return <Container className='mt-4 border shadow p-0 text-center bg-white rounded overflow-hidden'>    

    { tipologia.KID === TIPOLOGIE.SENOLOGIA.KID && <HeaderSenologia subtitle="Questionario per la prevenzione del tumore del seno" /> } 
    { tipologia.KID === TIPOLOGIE.COLON_RETTO.KID && <HeaderColon subtitle="Questionario per la prevenzione del tumore del colon-retto" /> }     
    { tipologia.KID === TIPOLOGIE.TICKET_PS_STRANIERI.KID && <HeaderTicketPsStranieri subtitle="" /> }     

    <h1 className="text-primary">CREDITS</h1>

    <ul style={{ listStyle: 'none', paddingLeft: '0', marginLeft: '0' }}>
      <li>Realizzato da G&F Software S.r.l<br />via del fontanile arenato 171b 00163 Roma</li>
      { tipologia.KID === TIPOLOGIE.SENOLOGIA.KID && <CreditsSenologia tipologia={tipologia} /> } 
      { tipologia.KID === TIPOLOGIE.COLON_RETTO.KID && <CreditsColon tipologia={tipologia} /> }             
      { tipologia.KID === TIPOLOGIE.TICKET_PS_STRANIERI.KID && <CreditsTicketPsStranieri tipologia={tipologia} /> }             
    </ul>        

    <Button variant="link" size="lg" onClick={()=>navigate(-1)} className="my-4">
      <div className="d-flex flex-row align-items-center justify-content-between">
        <FaArrowLeft /><span className="ms-2">INDIETRO</span>
      </div>
    </Button>      
  
    <Footer tipologia={tipologia} />

  </Container>  
}

export default Credits;
